import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnChanges,
	SimpleChanges,
} from '@angular/core';
import { AuUtilsFunctions } from '@app/shared';
import { NgStyle } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { AuUserInitialsPipe } from '../../../pipes/au-user-initials.pipe';

export interface IAvatarData {
	smallAvatarUrl?: string;
	smallLogoUrl?: string;
	logoUrl?: string;
	firstName: string;
	lastName: string;
	fullName: string;
	name?: string;
	psId: string;
	displayName: string;
	imageUrl: string;
}

@Component({
	selector: 'au-round-avatar',
	templateUrl: './au-round-avatar.component.html',
	styleUrls: ['./au-round-avatar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgStyle, MatIcon, AuUserInitialsPipe],
})
export class AuRoundAvatarComponent implements OnChanges {
	@Input() data: Partial<IAvatarData>;
	@Input() smallAvatarUrl: string;
	@Input() fullName: string;
	@Input() imagePlaceHolder: string;
	@Input() size = 40;

	backgroundColor;

	ngOnChanges(changes: SimpleChanges) {
		if (changes.data) {
			const uuid = changes.data?.currentValue?.psId;
			this.backgroundColor = AuUtilsFunctions.getColorBasedByUuidColor(uuid);
		}
	}

	getPlaceholderFontSize(size: number): string {
		return size / 2 + 'px';
	}

	get avatarIsAvailable(): boolean {
		if (!this.data) {
			return !!this.smallAvatarUrl;
		}

		return (
			!!this.data.imageUrl ||
			!!this.data.smallAvatarUrl ||
			!!this.data.smallLogoUrl ||
			!!this.data.logoUrl
		);
	}

	get avatarUrl(): string {
		if (!this.data) {
			// Thought we have an *ngIf that checks if this.smallAvatarUrl is defined
			// we can be sure that if no this.data is provided, smallAvatarUrl is present
			return this.smallAvatarUrl;
		}

		return (
			this.data.imageUrl ||
			this.data.smallAvatarUrl ||
			this.data.smallLogoUrl ||
			this.data.logoUrl
		);
	}
}
